<template>
    <div>
        <slot></slot>
    </div>
</template>
<script>
	import { type, deepCopy } from '../../utils/assist'
    import Configurable from '../a-map/configurable'
    import EventAgent from '../a-map/eventAgent'

    // 插件-手动绘制覆盖物
	export default {
		name: "AMapMouseTool",

        mixins: [ Configurable, EventAgent ],

		inject: {
            amap: { default: null }
        },

        data(){
        	return {
                configExclude: "all",
        		mouseTool: null,
                geoJSONGroup: null,
        	}
        },

        props: {
            // 标准GeoJSON对象 sync
            geoJSON: {
                type: [Array, Object],
            },
            // 是否多标记
            multiple: {
                type: Boolean,
                default: false
            },
            // 绘图类型
            drawType: {
                type: String,
                validator(val){
                    return ["", 'marker', 'polyline', 'polygon', 'rectangle', 'circle', 'rule', 'measureArea', 'rectZoomIn', 'rectZoomOut'].indexOf(val) >= 0
                }
            },
            // 额外数据
        },

        model: {
            prop: 'geoJSON',
        },

        methods: {
        	initMouseTool(){
        		if(AMap && AMap.MouseTool){
        			this.mouseTool = new AMap.MouseTool(this.amap.map)
                    
                    // geoJSON对象配置 
                    this.renderGeoJSON()                 
                    // 捕获矢量图
                    this.mouseTool.on('draw', this.recordOverlays)
        			// 事件监听
                    this.startAgent(this.mouseTool)
                    // 初始化绘制
                    this.onDraw()

                    this.$emit("load", this.mouseTool, this.geoJSONGroup)

        			return this.mouseTool
        		}else{
        			return new Error("AMap.MouseTool插件未加载")
        		}
        	},
            // geoJSON数据更新，刷新标记
            renderGeoJSON(json){
                var geoJsonOps = {},
                    json = json || this.geoJSON

                if(json){
                    geoJsonOps.geoJSON = json
                }

                if(this.config.polygon){
                    geoJsonOps.getPolygon = (geojson, lnglat) => {
                        return new AMap.Polygon(Object.assign(this.config.polygon, { path: lnglat}))
                    }
                }

                if(this.config.marker){
                    geoJsonOps.getMarker = (geojson, lnglat) => {
                        return new AMap.Marker(Object.assign(this.config.marker, { position: lnglat}))
                    }
                }

                // todo polyline
                // if(this.config.polyline){
                //     geoJsonOps.getPolyline = (geojson, lnglat) => this.config.polyline
                // }
                
                // 删除旧group
                if(this.geoJSONGroup){
                    this.geoJSONGroup.clearOverlays()
                }
                // 创建新Group
                this.geoJSONGroup = new AMap.GeoJSON(geoJsonOps)
                // setMap
                this.geoJSONGroup.setMap(this.amap.map)
            },  
            // 缓存标记
            recordOverlays(e){
                // 单选
                if(!this.multiple){
                    this.geoJSONGroup.clearOverlays()
                }
                this.geoJSONGroup.addOverlay(e.obj)
                this.updateOverlays()
            },
            // 标记更新
            updateOverlays(){
                this.$emit("input", this.getGeoJSON())
            },
            // 开始绘图
            onDraw(){
                if(this.drawType){
                    // 默认取多边形
                    var options = this.config.polygon || {}

                    if(this.drawType == "marker"){
                        options = this.config.marker || {}
                    }

                    if(this.drawType == "polyline" || this.drawType == "rule"){
                        options = this.config.polyline || {}
                    }

                    if(this.drawType == "circle"){
                        options = this.config.circle
                    }

                    this.mouseTool[this.drawType](options)    
                }else{
                    this.close()
                }
            },
            // 关闭矢量绘图
            close(flag){
                // 同时清空标记
                if(flag){
                    this.geoJSONGroup.clearOverlays()
                    this.updateOverlays()
                }
                this.mouseTool.close()
            },
            // 获取标记geoJSON数据
            getGeoJSON(){
                return this.geoJSONGroup ? this.geoJSONGroup.toGeoJSON() : null
            }
        },

        watch: {
            drawType(val){
                if(this.mouseTool){
                    this.onDraw()
                }
            },
            geoJSON(val){
                if(this.mouseTool && val){
                    this.renderGeoJSON(val)
                }
            },
            config: {
                handler(){
                    // 重置geoJSON Group
                    if(this.geoJSONGroup){
                        var json = this.geoJSONGroup.toGeoJSON()
                        
                        this.renderGeoJSON(json)
                    }
                },
                deep: true
            }
        },

		created(){
			this.$watch(function(){
				return this.amap.load
			}, function(load){
				// map 创建完毕
				if(load){
                    this.configBubble = false

					var mouseTool = this.initMouseTool()		

					if(type(mouseTool) == "error"){
						throw mouseTool
					}

					this.amap.mouseTools.push(mouseTool)
				}
			}, {
				immediate: true
			})
		},

		beforeDestroy(){
			if(this.mouseTool){
                // 清理覆盖物
                this.close(true)
                this.mouseTool.off("draw", this.recordOverlays)
                // 从amap移除
                this.amap.mouseTools.splice(this.amap.mouseTools.indexOf(this.mouseTool), 1)                
				// 事件解绑
                this.stopAgent(this.mouseTool)
			}
		}
	}
</script>